/*!
 * BoostrapVue 2.0.0-rc.21
 *
 * @link https://bootstrap-vue.js.org
 * @source https://github.com/bootstrap-vue/bootstrap-vue
 * @copyright (c) 2016-2019 BootstrapVue
 * @license MIT
 * https://github.com/bootstrap-vue/bootstrap-vue/blob/master/LICENSE
 */
import componentsPlugin from './components';
import directivesPlugin from './directives';
import { installFactory, vueUse } from './utils/plugins';
import { setConfig } from './utils/config';
var BootstrapVue = {
  install: installFactory({
    plugins: {
      componentsPlugin: componentsPlugin,
      directivesPlugin: directivesPlugin
    }
  }),
  setConfig: setConfig // Auto installation only occurs if window.Vue exists

};
vueUse(BootstrapVue);
export default BootstrapVue;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bootstrap-vue/es/index.js
// module id = null
// module chunks = 